import React, { FC } from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

type Title = string;
type Href = string;
type Link = ['link', Title, Href];
export const Link = (title: Title, href: Href): Link => ['link', title, href];

type Group = ['group', Title, Href, Link[]];
export const Group = (title: Title, href: string, links: Link[]): Group => [
  'group',
  title,
  href,
  links,
];

type Option = Link | Group;

interface Props {
  path: string;
  options: Option[];
}

const LinkItem = styled(NavLink)`
  display: block;
`;

const renderLink = (path: string, [, title, href]: Link) => (
  <LinkItem title={title} to={`${path}${href}`}>
    {title}
  </LinkItem>
);

const GroupHeader = styled.h5<{ $index: number; $total: number }>`
  height: var(--layout-03);
  position: sticky;
  top: ${({ $index }) => `calc(${$index} * var(--layout-03))`};
  background: var(--white-100);
  bottom: ${({ $total, $index }) =>
    `calc(${$total - $index - 1} * var(--layout-03))`};
  margin: var(--spacing-05) 0 var(--spacing-03);
`;

const renderGroup = (
  path: string,
  index: number,
  total: number,
  [, title, href, links]: Group,
) => (
  <>
    <GroupHeader $index={index} $total={total}>
      {title}
    </GroupHeader>
    {links.map((link) => renderLink(path + href, link))}
  </>
);

const ScrollContainer = styled.div`
  height: 100%;
  overflow-y: auto;
  padding: 0 var(--layout-03);
`;

const Wrapper = styled.div`
  height: 100%;
  overflow: hidden;
  padding: var(--layout-01) 0;
`;

export const Sider: FC<Props> = ({ path, options }) => (
  <Wrapper>
    <ScrollContainer>
      {options.map((option, i) =>
        option[0] === 'group'
          ? renderGroup(path, i, options.length, option)
          : renderLink(path, option),
      )}
    </ScrollContainer>
  </Wrapper>
);
